module.exports = __webpack_public_path__ + "static/img/transition_right.b3db375d.png";